import React from "react";
import "./ProductPortfolio.css";
import ProductPortfolioCard from "../../components/productPortfolioCard/ProductPortfolioCard";
import { productPortfolio } from "../../portfolio";
import { Fade } from "react-reveal";

export default function ProductPortfolio({ theme }) {
  return (
    <div className="main" id="product-portfolio">
      <div className="product-portfolio-main-div">
        {productPortfolio && productPortfolio.title && (
          <Fade bottom duration={1500} distance="50px">
            <div className="product-portfolio-header">
              <h1 className="heading product-portfolio-heading">
                {productPortfolio.title}
              </h1>
              {productPortfolio.subtitle && (
                <p className="subTitle product-portfolio-subtitle">
                  {productPortfolio.subtitle}
                </p>
              )}
            </div>
          </Fade>
        )}
        <div className="product-portfolio-grid">
          {productPortfolio.products &&
            productPortfolio.products.map((product, index) => (
              <Fade bottom duration={1000} distance="40px" key={index}>
                <ProductPortfolioCard product={product} theme={theme} />
              </Fade>
            ))}
        </div>
      </div>
    </div>
  );
}
